import { EnumValue } from "../../../library-templates/inspector/types/EnumValue";
import { MidiKey } from "../midi/MidiKey";
import { MusicKey, MusicKeys } from "./MusicKey";

export class MusicNote
{
  key = new EnumValue<MusicKey>( MusicKey );
  octave:number = 5;

  moveSemitones( semitones:number )
  {
    return MusicNote.fromMidiPitch( this.midiPitch + semitones );
  }

  get midiPitch()
  {
    let octaveOffset = ( this.octave + 1 ) * 12 ;
    let keyOffset   = MusicKeys.getOffset( this.key.value );

    return octaveOffset + keyOffset;
  }

  static fromMidiPitch( pitch:number )
  {
    pitch = Math.round( pitch );
    let octave = Math.floor( pitch / 12 ) - 1;
    let note = new MusicNote();
    note.octave = octave;
    note.key.value = MusicKeys.fromOffset( pitch );

    return note;
  }

  toString()
  {
    return MusicKey[ this.key.value ] + this.octave;  
  }
}